import request from '@/utils/request'
let baseURL = '/mall-jd';

// 京东店铺的商品卖价
export function getShopSkuPrice(data) {
  return request({
    url: '/goods/agent/v1/getShopSku',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
jdSku (integer, optional): jd_sku ,
shopId (integer, optional): shop_id
}
* */

// 京东店铺的商品卖价 批量
export function getShopSkuPriceMap(data) {
  return request({
    url: '/goods/agent/v1/getShopSku/map',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
list (Array[ShopSkuRequest], optional): 集合
}
ShopSkuRequest {
jdSku (integer): jd_sku ,
shopId (integer): shop_id
}
* */




//参数查看京东文档

// 1.1.6	获取PC端样式
// 	API名称（method）：jd.kpl.open.item.getwarestyleandjsbywareid
export function getJDPcStyle(data) {
  return request({
    url: '/goods/agent/v1/getPcStyle',
    method: 'post',
    baseURL,
    data
  })
}

// 1.1.7	获取移动端样式
// 	API名称（method）：jd.kpl.open.item.getmobilewarestyleandjsbywareid
export function getJDMobileStyle(data) {
  return request({
    url: '/goods/agent/v1/getMobileStyle',
    method: 'post',
    baseURL,
    data
  })
}

// 1.1.8	查询商品上下架状态接口
// 	API名称（method）：biz.product.state.query
//sku	Long	Y	商品编号，支持批量，以【，】分割，最高100个
export function getJDShelfState(data) {
  return request({
    url: '/goods/agent/v1/shelfState',
    method: 'post',
    baseURL,
    data
  })
}

// 1.1.9	查询所有图片信息接口
// 	API名称（method）：biz.product.skuImage.query
export function getJDSkuImage(data) {
  return request({
    url: '/goods/agent/v1/skuImage',
    method: 'post',
    baseURL,
    data
  })
}

// 1.1.11	查询商品区域购买限制接口
// 	API名称（method）：biz.product.checkAreaLimit.query
//skuIds	String	商品编号，支持批量，以【，】分割（最高支持50个）
export function getJDAreaLimit(data) {
  return request({
    url: '/goods/agent/v1/checkAreaLimit',
    method: 'post',
    baseURL,
    data
  })
}

// 1.1.12	查询商品区域是否支持货到付款接口
// 	API名称（method）：biz.product.isCod.query
export function getJDisCod(data) {
  return request({
    url: '/goods/agent/v1/isCod',
    method: 'post',
    baseURL,
    data
  })
}

// 1.1.13	查询赠品信息接口
// 	API名称（method）：biz.product.skuGift.query
export function getJDGoodsGift(data) {
  return request({
    url: '/goods/agent/v1/goodsGift',
    method: 'post',
    baseURL,
    data
  })
}

// 1.1.14	运费查询接口
// 	API名称（method）：biz.order.freight.get
export function getJDQueryFreight(data) {
  return request({
    url: '/goods/agent/v1/queryFreight',
    method: 'post',
    baseURL,
    data
  })
}

// 1.1.15	商品可售验证接口
// 		API名称（method）：biz.product.sku.check
// skuIds	String	是	商品编号，支持批量，以【,】分隔  (最高支持100个商品)
export function getJDSalesCheck(data) {
  return request({
    url: '/goods/agent/v1/salesCheck',
    method: 'post',
    baseURL,
    data
  })
}

// 1.1.20	同类商品查询接口
// 	API名称（method）：jd.biz.product.getSimilarSku
export function getJDSimilarSku(data) {
  return request({
    url: '/goods/agent/v1/similarSku',
    method: 'post',
    baseURL,
    data
  })
}

//1.1.21	获取京东预约日历
//	API名称（method）：biz.order.promise.calendar.get
export function getJDPromiseCalendar(data) {
  return request({
    url: '/goods/agent/v1/promiseCalendar',
    method: 'post',
    baseURL,
    data
  })
}



//查库存，根据SKU和地址
// 1.3.2 批量获取库存接口
// 	API名称（method）：jd.kpl.open.getnewstockbyid.query
export function getJDGoodsStock(data) {
  return request({
    url: '/goods/agent/v1/goodsStock',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
apiMethod (string, optional),
area (string, optional),
skuNums (Array[SkuAndNumVO], optional)
}
SkuAndNumVO {
num (integer, optional),
skuId (integer, optional)
}
* */


//
// 4.9	查询配送信息接口
// 	API名称（method）：biz.order.orderTrack.query
export function getJDOrderTrack(data) {
  return request({
    url: '/order/agent/v1/queryOrderTrack',
    method: 'post',
    baseURL,
    data
  })
}